import React, { createContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RouteConstants from "../../../constants/routeConstants.json";
import { roleListApi } from "../../../api/Api";
import { useCookies } from "react-cookie";
import ViewIcon from "../../../assets/images/right-more.png";
import { handleApiError } from "../../../constants/Constants";

export const RoleManageContext = createContext({});
export const RoleManageContextProvider = ({ children }) => {
  const [roleList, setRoleList] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [searchData, setSearchData] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [successPopupMessage, setSuccessPopupMessage] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  const [statusPopup, setStatusPopup] = useState(false);
  const [statusMessagePopup, setStatusMessagePopup] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [permissionsList, setPermissionsList] = useState();
  const [buttonText, setButtonText] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPage = location?.state?.page;
  const [pageCount, setPageCount] = useState(currentPage ? currentPage : 1);

  const permissionAccess = JSON.parse(
    localStorage.getItem("permissions")
  )?.filter((item) => {
    return item.feature === "66f50472b58f398ba8f04a8b";
  })[0];
  const roleIdentifier = JSON.parse(localStorage.getItem("roleIdentifier"));
  const isSuperAdmin = roleIdentifier === "superadmin";

  // search onChange
  const onChangeSearch = (e) => {
    const specialCharacters = /[!@#$%^&*(),.?":{}|<>+\-_\/=;]/;
    if (specialCharacters.test(e.target.value)) {
      e.preventDefault();
    } else {
      setSearchData(e.target.value);
      setPageCount(1);
    }
  };

  const roleManageListShow = async (page, search) => {
    try {
      setSpinnerStatus(true);
      const getRoleList = await roleListApi(page, search);
      if (getRoleList?.status === 200) {
        setSpinnerStatus(false);
        setRoleList(
          getRoleList?.data?.data?.roleList?.map((item) => ({
            ...item,
            role: item?.name,
            description: (
              <div>{item?.description ? item?.description : "-"}</div>
            ),
            user: item?.userCount ? item?.userCount : "0",
            action: (
              <div onClick={() => viewRoleData(item?._id)}>
                <span>
                  <img className="viewClickAdmin" src={ViewIcon} alt="view" />
                </span>
              </div>
            ),
          }))
        );
        setTotalPage(getRoleList?.data?.data?.totalPages);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  const viewRoleData = (id) => {
    navigate(RouteConstants.VIEW_ROLE, { state: { id, page: pageCount } });
  };

  const roleToLogin = () => {
    navigate(RouteConstants.LOGIN);
    removeCookie("x-access-token");
  };

  const addRole = () => {
    navigate(RouteConstants.ADD_ROLE);
  };

  const onPageChange = (e) => {
    setPageCount(e);
  };

  // close success modal
  const closeSuccessModal = () => {
    setSuccessPopup(false);
  };

  // close error modal
  const onHandleClose = () => {
    setErrorPopup(false);
  };

  const providerValue = {
    roleManageListShow,
    onPageChange,
    roleList,
    pageCount,
    roleToLogin,
    statusValue,
    buttonText,
    searchData,
    setSearchData,
    totalPage,
    deletePopup,
    addRole,
    successPopup,
    successPopupMessage,
    setDeletePopup,
    errorPopup,
    spinnerStatus,
    errorPopupMessage,
    roleManageListShow,
    isSuperAdmin,
    // success modal close function
    closeSuccessModal,
    setErrorPopup,
    onChangeSearch, // search on change

    onHandleClose, // error modal close
    permissionAccess,
  };
  return (
    <RoleManageContext.Provider value={providerValue}>
      {children}
    </RoleManageContext.Provider>
  );
};
